export const LOAD_DEVICES = "LOAD_DEVICES";
export const LOAD_DEVICES_SUCCESS = "LOAD_DEVICES_SUCCESS";
export const LOAD_DEVICES_ERROR = "LOAD_DEVICES_ERROR";
